import type { CSSProperties, ReactNode } from 'react'

type CardVariant = 'default' | 'sm' | 'elevated'

const CLASS: Record<CardVariant, string> = {
  default: 'card',
  sm: 'card-sm',
  elevated: 'card-elevated',
}

interface CardProps {
  variant?: CardVariant
  className?: string
  style?: CSSProperties
  children?: ReactNode
  onClick?: () => void
  'data-testid'?: string
}

/**
 * Card — the base surface used across every screen. Thin wrapper over the
 * `.card` / `.card-sm` / `.card-elevated` design-system classes in globals.css.
 * Aurora+ source: cannaspy_s04 / s07 / s12 panels.
 */
export function Card({ variant = 'default', className, style, children, onClick, ...rest }: CardProps) {
  return (
    <div
      className={[CLASS[variant], className].filter(Boolean).join(' ')}
      style={style}
      onClick={onClick}
      data-testid={rest['data-testid']}
    >
      {children}
    </div>
  )
}
